import React from "react";
import { useIntl } from "react-intl";

export default function NotAuthorized() {
  const intl = useIntl();
  return (
    <div style={{ textAlign: "center" }}>
      <p>{intl.formatMessage({ id: "Not.Authorized" })}</p>
    </div>
  );
}
